var map = {
	"./SCO23_mosaic": 41,
	"./SCO23_mosaic.jpg": 41,
	"./backgrounds/texture-2021-light-01": 42,
	"./backgrounds/texture-2021-light-01.png": 42,
	"./badge": 43,
	"./badge.png": 43,
	"./badge/a-bersaglio": 44,
	"./badge/a-bersaglio.png": 44,
	"./badge/a-bersaglio_secondary": 45,
	"./badge/a-bersaglio_secondary.png": 45,
	"./badge/abbonato": 46,
	"./badge/abbonato.png": 46,
	"./badge/abbonato_secondary": 47,
	"./badge/abbonato_secondary.png": 47,
	"./badge/appassionato": 48,
	"./badge/appassionato.png": 48,
	"./badge/appassionato_secondary": 49,
	"./badge/appassionato_secondary.png": 49,
	"./badge/apprendista": 50,
	"./badge/apprendista.png": 50,
	"./badge/apprendista_secondary": 51,
	"./badge/apprendista_secondary.png": 51,
	"./badge/campionato-bracket-perfetto": 52,
	"./badge/campionato-bracket-perfetto.png": 52,
	"./badge/campionato-bracket-perfetto_secondary": 53,
	"./badge/campionato-bracket-perfetto_secondary.png": 53,
	"./badge/campionato-finalista": 54,
	"./badge/campionato-finalista.png": 54,
	"./badge/campionato-finalista_secondary": 55,
	"./badge/campionato-finalista_secondary.png": 55,
	"./badge/campionato-vincente": 56,
	"./badge/campionato-vincente.png": 56,
	"./badge/campionato-vincente_secondary": 57,
	"./badge/campionato-vincente_secondary.png": 57,
	"./badge/cecchino": 58,
	"./badge/cecchino.png": 58,
	"./badge/cecchino_secondary": 59,
	"./badge/cecchino_secondary.png": 59,
	"./badge/cervellone": 60,
	"./badge/cervellone.png": 60,
	"./badge/cervellone_secondary": 61,
	"./badge/cervellone_secondary.png": 61,
	"./badge/conquiztador": 62,
	"./badge/conquiztador.png": 62,
	"./badge/conquiztador_secondary": 63,
	"./badge/conquiztador_secondary.png": 63,
	"./badge/coppa-italia-bracket-perfetto": 64,
	"./badge/coppa-italia-bracket-perfetto.png": 64,
	"./badge/coppa-italia-bracket-perfetto_secondary": 65,
	"./badge/coppa-italia-bracket-perfetto_secondary.png": 65,
	"./badge/coppa-italia-finalista": 66,
	"./badge/coppa-italia-finalista.png": 66,
	"./badge/coppa-italia-finalista_secondary": 67,
	"./badge/coppa-italia-finalista_secondary.png": 67,
	"./badge/coppa-italia-vincente": 68,
	"./badge/coppa-italia-vincente.png": 68,
	"./badge/coppa-italia-vincente_secondary": 69,
	"./badge/coppa-italia-vincente_secondary.png": 69,
	"./badge/debuttante": 70,
	"./badge/debuttante.png": 70,
	"./badge/debuttante_secondary": 71,
	"./badge/debuttante_secondary.png": 71,
	"./badge/esperto": 72,
	"./badge/esperto.png": 72,
	"./badge/esperto_secondary": 73,
	"./badge/esperto_secondary.png": 73,
	"./badge/fan-sfegatato": 74,
	"./badge/fan-sfegatato.png": 74,
	"./badge/fan-sfegatato_secondary": 75,
	"./badge/fan-sfegatato_secondary.png": 75,
	"./badge/fedelissimo": 76,
	"./badge/fedelissimo.png": 76,
	"./badge/fedelissimo_secondary": 77,
	"./badge/fedelissimo_secondary.png": 77,
	"./badge/fenomeno": 78,
	"./badge/fenomeno.png": 78,
	"./badge/fenomeno_secondary": 79,
	"./badge/fenomeno_secondary.png": 79,
	"./badge/genio": 80,
	"./badge/genio.png": 80,
	"./badge/genio_secondary": 81,
	"./badge/genio_secondary.png": 81,
	"./badge/giorno-da-leoni": 82,
	"./badge/giorno-da-leoni.png": 82,
	"./badge/giorno-da-leoni_secondary": 83,
	"./badge/giorno-da-leoni_secondary.png": 83,
	"./badge/hero-member": 84,
	"./badge/hero-member.png": 84,
	"./badge/hero-member_secondary": 85,
	"./badge/hero-member_secondary.png": 85,
	"./badge/infallibile": 86,
	"./badge/infallibile.png": 86,
	"./badge/infallibile_secondary": 87,
	"./badge/infallibile_secondary.png": 87,
	"./badge/nerd": 88,
	"./badge/nerd.png": 88,
	"./badge/nerd_secondary": 89,
	"./badge/nerd_secondary.png": 89,
	"./badge/ninja": 90,
	"./badge/ninja.png": 90,
	"./badge/ninja_secondary": 91,
	"./badge/ninja_secondary.png": 91,
	"./badge/nostradamus": 92,
	"./badge/nostradamus.png": 92,
	"./badge/nostradamus_secondary": 93,
	"./badge/nostradamus_secondary.png": 93,
	"./badge/partita-fortunata": 94,
	"./badge/partita-fortunata.png": 94,
	"./badge/partita-fortunata_secondary": 95,
	"./badge/partita-fortunata_secondary.png": 95,
	"./badge/partita-perfetta": 96,
	"./badge/partita-perfetta.png": 96,
	"./badge/partita-perfetta_secondary": 97,
	"./badge/partita-perfetta_secondary.png": 97,
	"./badge/prime-armi": 98,
	"./badge/prime-armi.png": 98,
	"./badge/prime-armi_secondary": 99,
	"./badge/prime-armi_secondary.png": 99,
	"./badge/special-one": 100,
	"./badge/special-one.png": 100,
	"./badge/special-one_secondary": 101,
	"./badge/special-one_secondary.png": 101,
	"./badge/stratega": 102,
	"./badge/stratega.png": 102,
	"./badge/stratega_secondary": 103,
	"./badge/stratega_secondary.png": 103,
	"./badge/supercoppa-bracket-perfetto": 104,
	"./badge/supercoppa-bracket-perfetto.png": 104,
	"./badge/supercoppa-bracket-perfetto_secondary": 105,
	"./badge/supercoppa-bracket-perfetto_secondary.png": 105,
	"./badge/supercoppa-finalista": 106,
	"./badge/supercoppa-finalista.png": 106,
	"./badge/supercoppa-finalista_secondary": 107,
	"./badge/supercoppa-finalista_secondary.png": 107,
	"./badge/supercoppa-vincente": 108,
	"./badge/supercoppa-vincente.png": 108,
	"./badge/supercoppa-vincente_secondary": 109,
	"./badge/supercoppa-vincente_secondary.png": 109,
	"./badge/supporter": 110,
	"./badge/supporter.png": 110,
	"./badge/supporter_secondary": 111,
	"./badge/supporter_secondary.png": 111,
	"./badge/tattico": 112,
	"./badge/tattico.png": 112,
	"./badge/tattico_secondary": 113,
	"./badge/tattico_secondary.png": 113,
	"./badge/tifoso": 114,
	"./badge/tifoso.png": 114,
	"./badge/tifoso_secondary": 115,
	"./badge/tifoso_secondary.png": 115,
	"./badge/tiratore-scelto": 116,
	"./badge/tiratore-scelto.png": 116,
	"./badge/tiratore-scelto_secondary": 117,
	"./badge/tiratore-scelto_secondary.png": 117,
	"./badge/tuttologo": 118,
	"./badge/tuttologo.png": 118,
	"./badge/tuttologo_secondary": 119,
	"./badge/tuttologo_secondary.png": 119,
	"./badge/veggente": 120,
	"./badge/veggente.png": 120,
	"./badge/veggente_secondary": 121,
	"./badge/veggente_secondary.png": 121,
	"./banner/awards_desktop": 122,
	"./banner/awards_desktop.jpg": 122,
	"./banner/awards_mobile": 123,
	"./banner/awards_mobile.jpg": 123,
	"./banner/discovery_desktop": 124,
	"./banner/discovery_desktop.png": 124,
	"./banner/discovery_mobile": 125,
	"./banner/discovery_mobile.png": 125,
	"./banner/olimpia_virtus": 126,
	"./banner/olimpia_virtus.jpg": 126,
	"./banner/umana_desktop": 127,
	"./banner/umana_desktop.png": 127,
	"./banner/umana_mobile": 128,
	"./banner/umana_mobile.gif": 128,
	"./banner/unipolsai_desktop": 129,
	"./banner/unipolsai_desktop.jpg": 129,
	"./banner/unipolsai_mobile": 130,
	"./banner/unipolsai_mobile.gif": 130,
	"./blue_day": 131,
	"./blue_day.png": 131,
	"./btn-play": 132,
	"./btn-play.png": 132,
	"./docker": 133,
	"./docker.png": 133,
	"./icon_ball": 134,
	"./icon_ball.svg": 134,
	"./icon_coins": 135,
	"./icon_coins.svg": 135,
	"./jquery": 136,
	"./jquery.png": 136,
	"./loghi/FIP_logo_FIP_vert_bn_neg": 137,
	"./loghi/FIP_logo_FIP_vert_bn_neg.png": 137,
	"./loghi/app_store_badge": 138,
	"./loghi/app_store_badge.svg": 138,
	"./loghi/banner_legabasket": 139,
	"./loghi/banner_legabasket.jpg": 139,
	"./loghi/google-play-badge": 140,
	"./loghi/google-play-badge.svg": 140,
	"./loghi/icon_media": 141,
	"./loghi/icon_media.svg": 141,
	"./loghi/icon_media_scoreboard": 142,
	"./loghi/icon_media_scoreboard.svg": 142,
	"./loghi/icon_monitor": 143,
	"./loghi/icon_monitor.svg": 143,
	"./loghi/icon_tickets": 144,
	"./loghi/icon_tickets.svg": 144,
	"./loghi/lba4you-title": 145,
	"./loghi/lba4you-title.png": 145,
	"./loghi/lba50": 146,
	"./loghi/lba50.png": 146,
	"./loghi/lba_cares": 147,
	"./loghi/lba_cares.png": 147,
	"./loghi/lba_logo": 148,
	"./loghi/lba_logo.png": 148,
	"./loghi/lba_logo_finals": 149,
	"./loghi/lba_logo_finals.png": 149,
	"./loghi/lba_logo_finals_mob": 150,
	"./loghi/lba_logo_finals_mob.png": 150,
	"./loghi/lba_logo_mob": 151,
	"./loghi/lba_logo_mob.png": 151,
	"./loghi/lba_logo_po": 152,
	"./loghi/lba_logo_po.png": 152,
	"./loghi/lba_logo_po_mob": 153,
	"./loghi/lba_logo_po_mob.png": 153,
	"./loghi/lba_logo_sc": 154,
	"./loghi/lba_logo_sc.png": 154,
	"./loghi/lba_logo_sc_mob": 155,
	"./loghi/lba_logo_sc_mob.png": 155,
	"./loghi/lba_podcast": 156,
	"./loghi/lba_podcast.png": 156,
	"./loghi/lba_white": 157,
	"./loghi/lba_white.png": 157,
	"./loghi/lbacares": 158,
	"./loghi/lbacares.png": 158,
	"./loghi/lbatv-banner": 159,
	"./loghi/lbatv-banner.png": 159,
	"./loghi/lbatv-title": 160,
	"./loghi/lbatv-title.png": 160,
	"./loghi/mail_header": 161,
	"./loghi/mail_header.png": 161,
	"./loghi/mylba": 162,
	"./loghi/mylba.png": 162,
	"./loghi/mylba_pos_hor": 163,
	"./loghi/mylba_pos_hor.png": 163,
	"./loghi/mylba_title": 164,
	"./loghi/mylba_title.png": 164,
	"./loghi/placeholder": 165,
	"./loghi/placeholder.png": 165,
	"./loghi/predictor_correct": 166,
	"./loghi/predictor_correct.svg": 166,
	"./loghi/predictor_wrong": 167,
	"./loghi/predictor_wrong.svg": 167,
	"./loghi/supercoppa": 168,
	"./loghi/supercoppa.jpeg": 168,
	"./logo": 169,
	"./logo.svg": 169,
	"./logo_sc23": 170,
	"./logo_sc23.png": 170,
	"./mailer/badge_1": 171,
	"./mailer/badge_1.png": 171,
	"./mailer/badge_2": 172,
	"./mailer/badge_2.png": 172,
	"./mailer/badge_3": 173,
	"./mailer/badge_3.png": 173,
	"./mailer/footer": 174,
	"./mailer/footer.jpg": 174,
	"./mailer/gamification": 175,
	"./mailer/gamification.jpg": 175,
	"./mosaic": 26,
	"./mosaic.jpg": 192,
	"./mosaic.svg": 26,
	"./mosaic_cut": 176,
	"./mosaic_cut.svg": 176,
	"./player-cutout-big-placeholder": 177,
	"./player-cutout-big-placeholder.png": 177,
	"./rails": 178,
	"./rails.png": 178,
	"./ruby": 179,
	"./ruby.png": 179,
	"./ticket-outline": 180,
	"./ticket-outline.svg": 180,
	"./webpack": 181,
	"./webpack.png": 181,
	"./yarn": 182,
	"./yarn.png": 182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 191;